module.exports = __webpack_public_path__ + "static/media/img-card (1).6af1f940.jpg";